import { useCallback, useMemo } from "react";

import * as Constants from "../../../_constants";
import { useHandleSearchParams } from "../../../_hooks";

export const useHandleFilterByOption = () => {
	const {
		// オプション ID（表示するオプション）
		optionIdList,
		//
		// オプション ID（表示するオプション）のセット
		onSetOptionIdList,
	} = useHandleSearchParams();

	/**
	 * 空配列の場合は、全てのオプションを表示する
	 */
	const displayOptionIdList = useMemo(() => optionIdList, [optionIdList]);

	/**
	 * 全てのオプションを表示
	 */
	const onDisplayAllOption = useCallback(() => {
		onSetOptionIdList([Constants.FilterValue.displayAll]);
	}, [onSetOptionIdList]);
	/**
	 * 全てのオプションを非表示
	 */
	const onHideAllOption = useCallback(() => {
		onSetOptionIdList([]);
	}, [onSetOptionIdList]);
	/**
	 * 表示するオプションの追加
	 */
	const onAddDisplayOption = useCallback(
		(optionId: string) => {
			/**
			 * 全てを表示していれば、全てを表示フラグを削除する
			 */
			const append = optionIdList.filter((id) => id !== Constants.FilterValue.displayAll).concat(optionId);
			onSetOptionIdList(append);
		},
		[onSetOptionIdList, optionIdList],
	);
	/**
	 * 表示するオプションの削除
	 */
	const onRemoveDisplayOption = useCallback(
		(optionId: string) => {
			const remove = optionIdList.filter((id) => id !== optionId);
			onSetOptionIdList(remove);
		},
		[onSetOptionIdList, optionIdList],
	);

	return {
		// オプション ID（表示するオプション）
		displayOptionIdList,
		//
		// 全てのオプションを表示
		onDisplayAllOption,
		// 全てのオプションを非表示
		onHideAllOption,
		// 表示するオプションの追加
		onAddDisplayOption,
		// 表示するオプションの削除
		onRemoveDisplayOption,
	};
};
